<template>
  <Block :title="displayTitle" emoji="🏆">
    <template v-if="viewMoreLink" #actions>
      <router-link :to="viewMoreLink" class="text-xs text-primary-dark hover:underline">
        {{ t("view_more") }}
      </router-link>
    </template>
    <BlockList :items="topSellers">
      <template #default="{ item: seller, index }">
        <span class="truncate">
          {{ index + 1 }}. {{ seller.seller.name }}
          <span class="text-gray-500">- {{ seller.seller.storeSalesChannel }}</span>
        </span>
        <span class="whitespace-nowrap ml-2">
          {{ $t("roadmap.sales", seller.salesCount) }}
          <template v-if="seller.totalSellerAmount">
            ·
            <span class="text-green-600 font-semibold">
              {{ formatPrice(seller.totalSellerAmount) }}
            </span>
          </template>
        </span>
      </template>
    </BlockList>
  </Block>
</template>

<script>
import { Block, BlockList, formatPrice } from "@estaly/ui";
import { useI18n } from "vue-i18n";

const TOP_COUNT = 5;

export default {
  components: {
    Block,
    BlockList,
  },
  setup() {
    const { t } = useI18n();
    return { t };
  },
  props: {
    sellerRanking: {
      type: Array,
      default: () => [],
    },
    viewMoreLink: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
  },
  computed: {
    displayTitle() {
      return this.title || this.t("title");
    },
    topSellers() {
      return this.sellerRanking.slice(0, TOP_COUNT);
    },
  },
  methods: {
    formatPrice,
  },
};
</script>

<i18n src="./TopSellersBlock.i18n.json"></i18n>
